import service from '../../utils/request'
import allUrl from "../../utils/setUrl"
import setting from "../../utils/setting"

//获取验证码
export function sendCode(params) {
  return service({
    url: allUrl.home + '/sms/sendCode',
    method: "get",
    params
  })
}

// 学生手机号登录
export function phoneLogin(params) {
  return service({
    // url:allUrl.home+'/student/phoneLogin',
    url: allUrl.home + '/student/phoneLoginPersonal',
    method: "get",
    params
  })
}

// 获取用户信息
export function getStudentInfo(params) {
  return service({
    url: allUrl.home + '/student/getStudentInfo',
    method: "get",
    params
  })
}

// 学生手机号登录
export function wxOpenidLogin(params) {
  return service({
    url: allUrl.home + '/student/wxOpenidLogin',
    method: "get",
    params
  })
}


// 查询学生报名进展
export function queryRegistrationProgress(params) {
  return service({
    url: allUrl.home + '/registrationprogress/queryRegistrationProgress',
    method: "get",
    params
  })
}


// 我的课程
export function getByStudentNo(params) {
  return service({
    url: allUrl.home + '/sign/userinfo/getByStudentNo',
    method: "get",
    params
  })
}

// 我的成绩
export function getMyCouseAchievement(params) {
  return service({
    url: allUrl.home + '/course/getMyCourseAchievement',
    method: "get",
    params
  })
}


// 撤销报名进度
export function deleteEnrollingStudent(data) {
  return service({
    url: allUrl.home + '/student/deleteEnrollingStudent',
    method: "post",
    data
  })
}

// 电子学生卡信息
export function getStudentStatusByUserId(data) {
  return service({
    url: allUrl.home + '/student/getStudentInfoByUserId',
    method: "post",
    data
  })
}
// 电子学生卡信息二维码 /edu/indeximg/genQrCodeRol
export function genQrCodeRol(params) {
  return service({
    url: setting.baseOtherTwoUrl + 'edu/indeximg/genQrCodeRoll',
    method: "get",
    params
  })
}

export function getMyCourseList(params) {
  return service({
    url: allUrl.home + '/course/getMyCourseList',
    method: "get",
    params
  })
}
export function getByTypeAndLevel(params){
  return service({
    url:allUrl.home+'/sys/dict/getByTypeAndLevel',
    method:"get",
    params
  })
}